/// <reference types="@angular/localize" />

import {
  enableProdMode,
  importProvidersFrom,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';
import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { APP_ROUTES } from './app/app-routing';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  PreloadAllModules,
  provideRouter,
  TitleStrategy,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
} from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { Apollo, provideNamedApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import {
  PAGINATION_CONFIG,
  AvatarColorPipe,
  GraphqlInterceptorInterceptor,
  SKIP_ERROR_HANDLING_OPERATIONS_LIST,
  defaultMatDialogConfig,
  CustomTitleStrategy,
} from '@tiltgroup/web-components';
// import { SqlOperator } from '@graphql-types';
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
import { DecimalPipe } from '@angular/common';

if (environment.production) {
  enableProdMode();
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    AvatarColorPipe,
    MatSnackBar,
    Apollo,

    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    provideRouter(
      APP_ROUTES,
      withPreloading(PreloadAllModules),
      inMemoryScrollingFeature
    ),
    importProvidersFrom(BrowserModule, MatDialogModule),
    provideAnimations(),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: defaultMatDialogConfig,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: GraphqlInterceptorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: SKIP_ERROR_HANDLING_OPERATIONS_LIST,
      useValue: ['ValidateLoad', 'UpdateLoadFromManager', 'CreateLoads'],
    },
    /*{
      provide: FILTER_COMPONENT_CONFIG,
      useValue: {
        operatorMap: {
          [SqlOperator.Eq]: 'equals',
          [SqlOperator.Neq]: 'does not equal',
          [SqlOperator.Gt]: 'greater than',
          [SqlOperator.Gte]: 'greater than or equals',
          [SqlOperator.Lt]: 'less than',
          [SqlOperator.Lte]: 'less than or equals',
          [SqlOperator.Like]: 'contains',
          [SqlOperator.NotLike]: 'does not contain',
          [SqlOperator.Ilike]: 'contains',
          [SqlOperator.NotIlike]: 'does not contain',
          [SqlOperator.StartsWith]: 'starts with',
          [SqlOperator.EndWith]: 'ends with',
          [SqlOperator.In]: 'is one of',
          [SqlOperator.NotIn]: 'is not one of',
          [SqlOperator.Between]: 'between',
          [SqlOperator.NotBetween]: 'not between',
          [SqlOperator.IsNull]: 'is not set',
          [SqlOperator.IsNotNull]: 'is set',
        },
        uniqueOperators: [SqlOperator.IsNull, SqlOperator.IsNotNull],
      },
    },*/
    {
      provide: PAGINATION_CONFIG,
      useValue: {
        paginationKey: 'paginatorInfo',
        currentPage: 'currentPage',
        lastPage: 'lastPage',
        total: 'total',
      },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'always',
        subscriptSizing: 'dynamic',
      },
    },
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        default: {
          cache: new InMemoryCache({
            typePolicies: {
              TableSettingPaginator: {
                keyFields: ['data'],
              },
              TableSetting: {
                keyFields: ['name', 'sort', 'columns', ['name']],
              },
            },
          }),
          link: httpLink.create({
            uri: environment.graphQLURL,
            extractFiles: (body) => extractFiles(body, isExtractableFile),
          }),
          defaultOptions: {
            watchQuery: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'ignore',
            },
            query: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'all',
            },
          },
        },
      };
    }),
    DecimalPipe,
  ],
}).catch((err) => console.error(err));
